import { useEffect } from "react";

const API_BASE = process.env.REACT_APP_API_BASE_URL || "http://localhost:5000";

const useTrackView = (module, id) => {
  useEffect(() => {
    if (!module || !id) return;
    const timer = setTimeout(() => {
      fetch(`${API_BASE}/api/frontend/views/${module}/${id}`, { method: "POST" }).catch(() => {});
    }, 5000);
    return () => clearTimeout(timer);
  }, [module, id]);
};

export default useTrackView;
